module.exports = __webpack_public_path__ + "img/2-1.45f3f937.jpg";